import React from "react";
import BoardCardShell from "../BoardCardShell";
import QuickLinksCard from "features/analytics/studio/components/home/QuickLinksCard";

/**
 * Quick links board card — wraps existing QuickLinksCard in the unified shell.
 */
export default function QuickLinksBoardCard({ card, onDelete, readOnly }) {
  const actions = readOnly ? [] : [
    ...(onDelete ? [{ label: "Delete", icon: "delete", onClick: onDelete, danger: true }] : []),
  ];

  return (
    <BoardCardShell
      title={card?.title || "Reports & cards"}
      actions={actions}
      readOnly={readOnly}
    >
      <div className="flex-1 min-h-0 overflow-auto">
        <QuickLinksCard />
      </div>
    </BoardCardShell>
  );
}
